/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Warm_Robin_BiteInputs */

const en_vivid_warm_robin_bite = /** @type {(inputs: Vivid_Warm_Robin_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove old users after import active`)
};

const de_vivid_warm_robin_bite = /** @type {(inputs: Vivid_Warm_Robin_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alte Benutzer nach Import löschen aktiviert`)
};

/**
* | output |
* | --- |
* | "Remove old users after import active" |
*
* @param {Vivid_Warm_Robin_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_warm_robin_bite = /** @type {((inputs?: Vivid_Warm_Robin_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Warm_Robin_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_warm_robin_bite(inputs)
	return de_vivid_warm_robin_bite(inputs)
});